<template>
<div class="v-validated">
  <slot v-bind="{ v: v$ }"/>
</div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
export default {
  data() {
    return {
      v$: useVuelidate(),
    }
  },
}
</script>